import { render } from "./UpdateInfoStatistic.vue?vue&type=template&id=aa044490"
import script from "./UpdateInfoStatistic.vue?vue&type=script&lang=js"
export * from "./UpdateInfoStatistic.vue?vue&type=script&lang=js"

import "./UpdateInfoStatistic.vue?vue&type=style&index=0&id=aa044490&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__